import React, {
    useMemo,
} from 'react'
import useOrderLink from 'app/hooks/useOrderLink/useOrderLink'
import {
    OrderTypes,
} from 'app/enums/label.enums'
import SkyNetLink, {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import useStyles from './OrderTableLink.style'

type Props = {
    rowProps: {
        orderNumber: string;
        orderType: OrderTypes
    }

}
const OrderTableLink = ({
    rowProps,
}: Readonly<Props>) => {
    const {
        orderNumber,
        orderType,
    } = rowProps
    const {
        classes,
    } = useStyles()
    const generateOrderLink = useOrderLink()

    const link = useMemo(() => {
        return generateOrderLink(orderNumber, orderType)
    }, [
        generateOrderLink,
        orderNumber,
        orderType,
    ])

    return (
        <SkyNetLink
            link={link}
            text={orderNumber}
            size={SizeLink.S}
            type={TypeLink.EXTERNAL}
            customClasses={{
                wrapper: classes.wrapper,
            }}
        />
    )
}

export default OrderTableLink
